module.exports = __webpack_public_path__ + "img/5_69.bdc6d4cf.png";